//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
export default {
    data(){
        return{
            phoneList:[
                {phone:'18312345678',amount:'20万',responseName:'医疗美容意外保险金'},
                {phone:'16218233919',amount:'10万',responseName:'医疗美容意外保险金'},
                {phone:'22222222222',amount:'30万',responseName:'医疗美容意外保险金'}
            ],
            swiperOption:{
                speed:2000,
                height: 15,
                direction: "vertical",
                autoplay: {
                    delay:8000  //这里需要注意，如果想每2秒去自动切换，直接autoplay:2000是失效的，
                },
                loop: true,
                disableOnInteraction : false,
                noSwiping : true,
                noSwipingClass : 'stop-swiping',
            },
            animHeigth:0
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    props:{
        gainInfo:{
            type:Array,
            default:[]
        }
    },
}
